import React, {useState, useEffect} from "react";
import {ViewAcademy, ThinTitle, TextAca, CardMapAcademy, Doubles, ViewCardList, ListPrograms, ProgramItem} from "./AcademyStyles";
import {Content} from "../../../styles/GlobalStyles";
import Color from "../../../assets/Colors";
import {Link} from "react-router-dom";
import parse from "html-react-parser";

import {ActionBio} from "../../course_details/components/FacilitadorStyle";

export default function Programas({data}) {
   const [isMobile, setMobile] = useState(true);
   useEffect(() => {
      setMobile(window.screen.width < 500);
   }, []);
   if (isMobile) {
      return (
         <ViewAcademy className="noPadding">
            <Content>
               <Doubles>
                  <ViewCardList>
                     {
                        <div
                           className="experienceImg"
                           style={{
                              backgroundImage: `url(http://domecqapi.trebolbit.com/${
                                 isMobile ? data.pathImageWebMobile : data.pathImageWebDesktop
                              })`,
                           }}
                        ></div>
                     }
                     <CardMapAcademy className="hasIcon toBottom">
                        <img
                           src={require("../../../assets/icons/acerca/programas_formacion_icon.png")}
                           alt="experience"
                           className="iconCard"
                           width="100%"
                        />
                        <ThinTitle color={Color.primary}>NUESTROS PROGRAMAS DE FORMACIÓN</ThinTitle>
                        <TextAca>{parse(data.description)}</TextAca>
                        {/* <TextAca>
                        Te invitamos a conocer los cuatro programas académicos a los que podrás aplicar según tu grado de
   conocimiento en la industria.
                        </TextAca> */}
                     </CardMapAcademy>
                  </ViewCardList>
                  <ViewCardList>
                     <ListPrograms>
                        <ProgramItem>
                           <img src={require("../../../assets/icons/acerca/cursos_icon.png")} alt="icon" className="iconProgram" />
                           <Link to="/cursos_esenciales">
                              <TextAca>
                                 Cursos <br /> Esenciales Domecq
                              </TextAca>
                           </Link>
                        </ProgramItem>
                        <ProgramItem>
                           <img src={require("../../../assets/icons/acerca/c_prime_icon.png")} alt="icon" className="iconProgram" />
                           <Link to="/certificado_prime">
                              <TextAca>
                                 Certificado <br /> Prime Domecq
                              </TextAca>
                           </Link>
                        </ProgramItem>
                     </ListPrograms>

                     <ListPrograms>
                        <ProgramItem>
                           <img src={require("../../../assets/icons/acerca/p_emblem_icon.png")} alt="icon" className="iconProgram" />
                           <Link to="/programa_emblem">
                              <TextAca>
                                 Programa <br /> Emblem Domecq
                              </TextAca>
                           </Link>
                        </ProgramItem>
                        <ProgramItem>
                           <img src={require("../../../assets/icons/acerca/p_enterprise_icon.png")} alt="icon" className="iconProgram" />
                           <Link to="/programa_enterprise">
                              <TextAca>
                                 Programa <br /> Enterprise Domecq
                              </TextAca>
                           </Link>
                        </ProgramItem>
                     </ListPrograms>
                  </ViewCardList>
               </Doubles>
            </Content>
         </ViewAcademy>
      );
   }

   return (
      <ViewAcademy className="noPadding">
         <Content>
            <Doubles>
               <ViewCardList>
                  <div
                     className="experienceImg"
                     style={{
                        backgroundImage: `url(http://domecqapi.trebolbit.com/${
                           isMobile ? data.pathImageWebMobile : data.pathImageWebDesktop
                        })`,
                     }}
                  ></div>
                  <CardMapAcademy className="hasIcon toBottom">
                     <img
                        src={require("../../../assets/icons/acerca/programas_formacion_icon.png")}
                        alt="experience"
                        className="iconCard"
                        width="100%"
                     />
                     <ThinTitle color={Color.primary}>NUESTROS PROGRAMAS DE FORMACIÓN</ThinTitle>
                     {/* <TextAca>
                        Te invitamos a conocer los cuatro programas académicos a los que podrás aplicar según tu grado de conocimiento en la
                        industria.
                     </TextAca> */}
                     <TextAca>{parse(data.description)}</TextAca>
                  </CardMapAcademy>
               </ViewCardList>
               <ViewCardList>
                  <ListPrograms>
                     <ProgramItem>
                        <img src={require("../../../assets/icons/acerca/cursos_icon.png")} alt="icon" className="iconProgram" />
                        <Link to="/cursos_esenciales">
                           <TextAca>
                              Cursos <br /> Esenciales Domecq
                           </TextAca>
                        </Link>
                     </ProgramItem>
                     <ProgramItem>
                        <img src={require("../../../assets/icons/acerca/c_prime_icon.png")} alt="icon" className="iconProgram" />
                        <Link to="/certificado_prime">
                           <TextAca>
                              Certificado <br /> Prime Domecq
                           </TextAca>
                        </Link>
                     </ProgramItem>
                     <ProgramItem>
                        <img src={require("../../../assets/icons/acerca/p_emblem_icon.png")} alt="icon" className="iconProgram" />
                        <Link to="/programa_emblem">
                           <TextAca>
                              Programa <br /> Emblem Domecq
                           </TextAca>
                        </Link>
                     </ProgramItem>
                     <ProgramItem>
                        <img src={require("../../../assets/icons/acerca/p_enterprise_icon.png")} alt="icon" className="iconProgram" />
                        <Link to="/programa_enterprise">
                           <TextAca>
                              Programa <br /> Enterprise Domecq
                           </TextAca>
                        </Link>
                     </ProgramItem>
                  </ListPrograms>
               </ViewCardList>
            </Doubles>
         </Content>
      </ViewAcademy>
   );
}
